import { convertNumberToLocaleString, STATUSPAGE } from '@repo/ui';
import { ValuePercentageGrowth } from 'domain/value-objects/value-percentage-growth';
import { useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Col } from 'reactstrap';

interface IProps {
  title: string;
  values: ValuePercentageGrowth;
  statusPage: STATUSPAGE;
  darkMode: 'dark' | 'light';
}

export const ActivitiesComparisonWidget = ({
  title,
  values,
  statusPage,
  darkMode,
}: IProps) => {
  const getIconClass = useCallback(() => {
    if (!values) return 'ri-arrow-right-line';
    if (values.percentageGrowth > 0) return 'ri-arrow-up-line';
    if (values.percentageGrowth < 0) return 'ri-arrow-down-line';
    return 'ri-arrow-right-line';
  }, [values, darkMode]);

  const getTextClass = useCallback(() => {
    if (!values) return darkMode === 'dark' ? 'text-white' : 'text-dark';
    if (values.percentageGrowth > 0) return 'text-success';
    if (values.percentageGrowth < 0) return 'text-danger';
    return darkMode === 'dark' ? 'text-white' : 'text-dark';
  }, [values, darkMode]);

  return (
    <Col>
      <p className="text-muted fw-medium fs-12 mb-0">{title}</p>
      {statusPage === STATUSPAGE.LOADING ? (
        <Skeleton
          baseColor="#e8e8e8c5"
          highlightColor="#bababa96"
          width={80}
          height={20}
        />
      ) : (
        <span className="fs-24 fw-medium mb-0">{values?.value ?? 'N/A'}</span>
      )}
      <div>
        {statusPage === STATUSPAGE.LOADING ? (
          <Skeleton
            baseColor="#e8e8e8c5"
            highlightColor="#bababa96"
            width={80}
          />
        ) : (
          <div>
            <i className={`${getIconClass()} ${getTextClass()}`}></i>
            <span className={`fs-13 fw-medium ${getTextClass()}`}>
              {convertNumberToLocaleString(values?.percentageGrowth, {
                hasPercentageSymbol: true,
                signDisplay: 'never',
              }) ?? 'N/A'}
            </span>
          </div>
        )}
      </div>
    </Col>
  );
};
